import {
  SELECTOR_PAX_MONTH_MENU_BLOCK,
  SELECTOR_PAX_MONTH_MENU_MONTH_ITEM,
  SELECTOR_PAX_MONTH_YEAR_PREV_BTN,
  SELECTOR_PAX_MONTH_YEAR_NEXT_BTN,
} from './pax-month-menu';

export default function TDPPaxMonthMenu() {
  let minNavigableYear = null;
  let maxNavigableYear = null;

  const filterNonHeaderElements = (selector) => {
    const newElements = [];

    $(selector).each((_, el) => {
      const isHeaderPaxSelector = $(el).closest('.ao-header-pax-selector').length > 0;
      if (!isHeaderPaxSelector) {
        newElements.push(el);
      }
    });

    return $(newElements);
  };

  const getYearBoundaries = (currentYear) => {
    const years = [currentYear, currentYear + 1, currentYear + 2];
    let minYear = null;
    let maxYear = null;

    years.forEach((year) => {
      const $yearBlock = filterNonHeaderElements(SELECTOR_PAX_MONTH_MENU_BLOCK).filter(`[data-year="${year}"]`);
      const availableMonths = $yearBlock
        .find(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM)
        .not('.ao-pax-month-menu__months-grid-month--unavailable')
        .length;

      if (availableMonths > 0) {
        if (minYear === null) minYear = year;
        maxYear = year;
      }
    });

    return { minYear, maxYear };
  };

  const updateNavigationState = (activeYear) => {
    const isPrevDisabled = activeYear <= minNavigableYear;
    const isNextDisabled = activeYear >= maxNavigableYear;

    filterNonHeaderElements(SELECTOR_PAX_MONTH_YEAR_PREV_BTN)
      .toggleClass('ao-pax-month-menu__selector-block-year-control-prev--disabled', isPrevDisabled);
    filterNonHeaderElements(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN)
      .toggleClass('ao-pax-month-menu__selector-block-year-control-next--disabled', isNextDisabled);
  };

  const updateYearsVisibility = (currentYear, activeYear, updateViewCallback) => {
    const boundaries = getYearBoundaries(currentYear);
    minNavigableYear = boundaries.minYear;
    maxNavigableYear = boundaries.maxYear;

    if (minNavigableYear === null || maxNavigableYear === null) {
      return activeYear;
    }

    let newActiveYear = activeYear;
    if (activeYear < minNavigableYear) {
      newActiveYear = minNavigableYear;
      updateViewCallback(newActiveYear);
    } else if (activeYear > maxNavigableYear) {
      newActiveYear = maxNavigableYear;
      updateViewCallback(newActiveYear);
    }

    updateNavigationState(newActiveYear);

    return newActiveYear;
  };

  const handlePrevClick = (activeYear, currentYear, updateViewCallback) => {
    if (activeYear > minNavigableYear && activeYear > currentYear) {
      const newActiveYear = activeYear - 1;
      updateViewCallback(newActiveYear);
      updateNavigationState(newActiveYear);
      return newActiveYear;
    }
    return activeYear;
  };

  const handleNextClick = (activeYear, currentYear, updateViewCallback) => {
    if (activeYear < maxNavigableYear && activeYear < currentYear + 2) {
      const newActiveYear = activeYear + 1;
      updateViewCallback(newActiveYear);
      updateNavigationState(newActiveYear);
      return newActiveYear;
    }
    return activeYear;
  };

  return {
    updateYearsVisibility,
    handlePrevClick,
    handleNextClick,
    updateNavigationState,
  };
}
